import { DAYS_TR } from './constants';

export const MONTHS_TR = [
  'Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran',
  'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık',
];

/** Tablo başlıkları için kısa ay adları */
export const MONTHS_TR_SHORT = [
  'Oca', 'Şub', 'Mar', 'Nis', 'May', 'Haz',
  'Tem', 'Ağu', 'Eyl', 'Eki', 'Kas', 'Ara',
];

const TR_MONTHS_MAP = {
  ocak: 1, şubat: 2, mart: 3, nisan: 4, mayıs: 5, haziran: 6,
  temmuz: 7, ağustos: 8, eylül: 9, ekim: 10, kasım: 11, aralık: 12,
};

/** "YYYY-MM-DD" → lokal Date (UTC kayması yok) */
export const parseISODateLocal = (dateStr) => {
  if (!dateStr || typeof dateStr !== 'string') return null;
  const [y, m, d] = dateStr.split('-').map(Number);
  if (!y || !m || !d) return null;
  return new Date(y, m - 1, d);
};

/** Bugünün tarihi — Türkiye lokal, ISO format */
export const getTodayISODate = () => {
  const now = new Date();
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, '0');
  const d = String(now.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
};

/** Haftanın gün adından en yakın tarih (bugün dahil) → ISO */
export const getNextISODateForDay = (dayName) => {
  const targetIdx = DAYS_TR.indexOf(dayName);
  if (targetIdx < 0) return getTodayISODate();
  const today = new Date();
  const todayIdx = today.getDay();
  let diff = targetIdx - todayIdx;
  if (diff < 0) diff += 7;
  const d = new Date(today);
  d.setDate(d.getDate() + diff);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
};

/** "2025-01-15" → "Çarşamba" (UTC kaymadan, lokal parse) */
export const getDayFromDate = (dateStr) => {
  const d = parseISODateLocal(dateStr);
  return d ? DAYS_TR[d.getDay()] : '';
};

export const formatDateTR = (dateVal) => {
  const d =
    typeof dateVal === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(dateVal)
      ? parseISODateLocal(dateVal)
      : new Date(dateVal);
  return d && !isNaN(d)
    ? d.toLocaleDateString('tr-TR', { day: 'numeric', month: 'long', year: 'numeric' })
    : dateVal;
};

export const formatDateTimeTR = (date) => {
  const d = new Date(date);
  return !isNaN(d)
    ? d.toLocaleDateString('tr-TR') +
        ' ' +
        d.toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' })
    : '';
};

/** "15 Ocak 2025" → "Ocak 2025" */
export const getMonthYear = (dateStr) => {
  const parts = (dateStr || '').trim().split(' ');
  return parts.length >= 3 ? `${parts[1]} ${parts[2]}` : null;
};

/** "Ocak 2025" karşılaştırması — kronolojik sıralama için */
export const compareMonthYear = (a, b) => {
  const [mA, yA] = a.split(' ');
  const [mB, yB] = b.split(' ');
  const yearDiff = parseInt(yA, 10) - parseInt(yB, 10);
  if (yearDiff !== 0) return yearDiff;
  return MONTHS_TR.indexOf(mA) - MONTHS_TR.indexOf(mB);
};

/** Geçerli ay-yıl etiketi: "Temmuz 2026" */
export const getCurrentMonthYear = () =>
  `${MONTHS_TR[new Date().getMonth()]} ${new Date().getFullYear()}`;

/** "15 Ocak 2025" → sıralanabilir sayı: 20250115 */
export const parseTRDate = (str) => {
  if (!str) return 0;
  const parts = str.trim().split(' ');
  if (parts.length < 3) return 0;
  const day = parseInt(parts[0], 10);
  const month = TR_MONTHS_MAP[parts[1].toLowerCase()] || 0;
  const year = parseInt(parts[2], 10);
  return year * 10000 + month * 100 + day;
};
